// extracted by mini-css-extract-plugin
export var gif = "_kq-0";